import {DEFAULT_ERROR} from './constants';

class RequestError extends Error {
  status: number;
  validationErrors: string[]
  constructor(status = 400, responseData) {
    super();

    const errorData = responseData || {};

    this.message = errorData.message || DEFAULT_ERROR;
    this.status = status;
    this.validationErrors = errorData.validationErrors;
    this.name = 'RequestError';
  }
}

export default RequestError;
